
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchPlaces } from './features/places/placesSlice';
import { validateLogin } from './features/user/userSlice';
import { Routes, Route } from 'react-router-dom';
import NavigationBar from "./components/NavigationBar";
import Home from './pages/HomePage';
import OAuthSuccessPage from './pages/OAuthSuccessPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import UserProfilePage from './pages/UserProfilePage';
import AddLocationsPage from './pages/AddLocationsPage';
import HikingTrailsPage from './pages/HikingTrailsPage';
import CampingSpotsPage from './pages/CampingSpotsPage';
import OverlooksPage from './pages/OverlooksPage';
import HikingDetailPage from './pages/HikingDetailPage';
import CampingDetailPage from './pages/CampingDetailPage';
import OverlookDetailPage from './pages/OverlookDetailPage';
import Footer from './components/Footer';
import ScrollToTop from './utils/scrollToTop';

import './App.css';

function App() {

    const dispatch = useDispatch();

    useEffect(() => {

        const init = async () => {
            const result = await dispatch(validateLogin())
            if (result.meta.requestStatus === 'fulfilled') {
                dispatch(fetchPlaces())
            }
        };
        init();
    }, [dispatch]);

    return (
        <div className='d-flex flex-column min-vh-100'>
            <NavigationBar />
            <ScrollToTop />
            <main className='flex-grow-1 top-padding-adjustment'>
                <Routes>
                <Route path='/' element={<Home />} />
                <Route path='forgot-password' element={<ForgotPasswordPage />} />
                <Route path='reset-password/:token' element={<ResetPasswordPage />} />
                <Route path='oauth-success' element={<OAuthSuccessPage />} />
                <Route path='profile' element={<UserProfilePage />} />
                <Route path='add-locations' element={<AddLocationsPage />} />
                <Route path='hiking-trails' element={<HikingTrailsPage />} />
                <Route path='hiking-trails/:id' element={<HikingDetailPage />} />
                <Route path='camping-spots' element={<CampingSpotsPage />} />
                <Route path='camping-spots/:id' element={<CampingDetailPage />} />
                <Route path='scenic-overlooks' element={<OverlooksPage />} />
                <Route path='scenic-overlooks/:id' element={<OverlookDetailPage />} />
            </Routes>
            </main>
            <Footer fixed="bottom" />
        </div>

    );
}

export default App;
